import Tabs from "@/components/Tabs";
import { useFlags } from "@/hooks/useFeatureFlags";
import AppLayout from "@/layouts/AppLayout";
import { useNavigate } from "@/router";
import type { Path } from "@/router";
import { useLocation } from "react-router-dom";

function EducationTabs() {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const flags = useFlags();
  const scormFlagEnabled = !!flags["backoffice-scorm-courses"];

  const items = [
    {
      label: scormFlagEnabled ? "Online Courses" : "Online Videos & Assessments",
      to: "/education/videos" as const
    },
    {
      label: "PGM Universities",
      to: "/education/universities" as const
    }
  ];

  return (
    <Tabs
      tabItems={items.map(({ label, to }) => ({
        label,
        onClick: () => navigate(to as Path),
        active: (pathname.endsWith("/") ? pathname.slice(0, -1) : pathname) === to
      }))}
    />
  );
}

export default function TabLayout({ children }: { children: React.ReactNode }) {
  return (
    <AppLayout>
      <EducationTabs />
      <div className="flex flex-col">{children}</div>
    </AppLayout>
  );
}
